import api from 'api';
import storage from "@/cflow/storageService";

class laboratorioService {

    listar() {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/laboratorio?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
export default new laboratorioService();